module.exports = __webpack_public_path__ + "img/left.ce159d18.png";